import { Injectable, EventEmitter } from '@angular/core';
import { AffiliateParams } from '../class/affiliateParams';
import { UntypedFormGroup } from '@angular/forms';

@Injectable({
  providedIn: 'root'
})
export class SharedService {
  private _affiliateParams: AffiliateParams;
  private _requestedPage: string;
  private _RDD: boolean;
  private _Interviewer: boolean;
  affiliateLogin = false;
  testVendor = false;
  userName: string;
  tempPass: string;
  lastUrl: string;

  // share number of members between form1 and 2
  numMembers = 1;

  // share number of devices between form1 and 2
  numComputers = 0;
  numTablets = 0;
  numSmartphones = 0;

  // share numberbetween form4 and others
  numComputersReg = 0;
  numTabletsReg = 0;
  numSmartphonesReg = 0;

  // share deviceLabel form14 and last
  deviceLabel = '';
  deviceId = 0;
  deviceSubtype = '';

  // share Labels form respective forms
  smartphoneLabels: string[] = [];

  // Logout from header menu event
  onProfileMenuClick = new EventEmitter<string>();
  onProfileDeviceSubsection = new EventEmitter<string>();
  onProfilePeopleSubsection = new EventEmitter<string>();

  // install device type
  installDeviceSubType: string;

  // share household id and country id
  sdpHouseholdId = 0;
  guid: string;
  countryId = 39;
  pegaHouseholdId: string;
  errorOccured: boolean;
  usernameEvent = new EventEmitter<string>();

  // Registration event
  registrationPageActive = new EventEmitter<boolean>();
  profilePageActive = new EventEmitter<boolean>();

  // Profile people event
  peopleBackClicked = new EventEmitter<boolean>();
  peopleBack2EditClicked = new EventEmitter<boolean>();
  // Profile devices event
  devicesBackClicked = new EventEmitter<boolean>();
  devicesBack2EditClicked = new EventEmitter<boolean>();
  devicesBack2AddClicked = new EventEmitter<boolean>();
  onMeterMandary = new EventEmitter<boolean>();

  // site events
  // Login event
  onLoginEvent = new EventEmitter<{
    loggedIn: boolean;
    profileAccess: boolean;
  }>();

  // naigate sections from home menu
  sectionToGo: string;
  onHomeMenuClick = new EventEmitter<string>();

  // share profile new member using device
  newDeviceMember = false;
  newDeviceMemberDevice: number = null;
  newMemberDevice = false;
  newDeviceMemberID: number = null;
  // Flag variable to identify scenario where a member is added from device form.
  isNewDeviceMemberScenario = false;
  // Flag variable to identify scenario where a device is added from member form.
  isNewMemberDeviceScenario = false;

  // rdd token
  rddToken: string;

  // to share last page between signin and change pass
  lastPage: number;

  constructor() { }

  set isRDD(val: boolean) {
    this._RDD = val;
  }
  get isRDD(): boolean {
    return this._RDD;
  }

  set isInterviewer(val: boolean) {
    this._Interviewer = val;
  }
  get isInterviewer(): boolean {
    return this._Interviewer;
  }

  set requestedPage(val: string) {
    this._requestedPage = val;
  }
  get requestedPage(): string {
    return this._requestedPage;
  }
  set affiliateParams(val: AffiliateParams) {
    this._affiliateParams = val;
  }
  get affiliateParams(): AffiliateParams {
    return this._affiliateParams;
  }

  scrollToControl(el: Element) {
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  }
  scrollToElementField(elementId: string) {
    const firstError = document.querySelector(elementId);
    this.scrollToControl(firstError);
  }

  scrollToError() {
    const firstError = document.querySelector('[formcontrolname].ng-invalid');
    this.scrollToControl(firstError);
  }
  async scrollFormError(form: UntypedFormGroup) {
    await form.invalid;
    this.scrollToError();
  }

  scrollProfileTop() {
    const a = document.getElementById('profile');
    if (a) {
      try {
        a.scroll(0, 0);
      } catch (e) {
        a.scrollTop = 0;
      }
    }
  }

  reinitVars() {
    this.newDeviceMember = false;
    this.newDeviceMemberDevice = null;
    this.newMemberDevice = false;
    this.newDeviceMemberID = null;

    this.isNewMemberDeviceScenario = false;
    this.isNewDeviceMemberScenario = false;
  }
}
